import { useEffect } from 'react';
import { ErrorLike } from '@apollo/client';

import { Snackbar } from '@atom/mui';
import { getErrorCode } from '@atom/utilities/validationUtilities';

type ErrorMessageMap = {
  [code: number]: string;
};

const DEFAULT_ERROR_MESSAGE = 'An unknown error occurred. Please try again.';

export const useErrorNotification = (
  error: ErrorLike,
  errorMessageMap: ErrorMessageMap,
  defaultMessage?: string,
) => {
  useEffect(() => {
    if (error) {
      const statusCode = getErrorCode(error);

      const message =
        errorMessageMap[statusCode] || defaultMessage || DEFAULT_ERROR_MESSAGE;

      Snackbar.error({
        message,
      });
    }
  }, [error]);
};
